import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import { DataColumn } from "../controls/Data.default";
import {
  buildSearchQuery,
  comboboxValue,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { InputObject } from "../controls/default";

export interface VariablesForm {
  readonly uid?: string;
  readonly rowVersion?: string;
  readonly name: string;
  readonly tag: string;
  readonly description: string;
  readonly contentType: InputObject;
  readonly variableType: InputObject;
  readonly value: string;
}

export const variablesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Description",
    key: "description",
    width: 320,
    sort: true,
  },
  {
    title: "Tag",
    key: "tag",
    width: 220,
    sort: true,
  },
  {
    title: "Content Type",
    key: "contentType",
    width: 160,
    sort: true,
  },
  {
    title: "Variable Type",
    key: "variableType",
    width: 160,
    sort: true,
  },
  {
    title: "Value",
    key: "value",
    width: 220,
    sort: true,
  },
  {
    title: "Created On",
    key: "createdOn",
    width: 168,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
  {
    title: "Updated On",
    key: "updatedOn",
    width: 168,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
];

const variablesQueryMappings: QueryFieldMapping[] = [
  { formField: "name", operation: QueryOperation.StartsWith },
  { formField: "description", operation: QueryOperation.StartsWith },
  { formField: "tag", operation: QueryOperation.StartsWith },
  { formField: "contentType", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "variableType", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "value", operation: QueryOperation.StartsWith },
];

export const mapVariablesViewQuery = (values: VariablesForm): SearchQuery =>
  buildSearchQuery(values, variablesQueryMappings);
